import { patchSegment } from '@gonfalon/openapi/operations/patchSegment';
import { getQueryClient } from '@gonfalon/react-query-client/getQueryClient';

import { createMutationHook } from '../internal/createMutationHook';
import { segments } from '../queries/segments';

export const useUpdateSegment = createMutationHook(patchSegment, {
  onSuccess: async (_, { projectKey, environmentKey, segmentKey }) => {
    const queryClient = getQueryClient();
    await queryClient.invalidateQueries({ queryKey: segments.list._def });
    await queryClient.invalidateQueries({
      queryKey: segments.detail({ projectKey, environmentKey, segmentKey }).queryKey,
    });
  },
});
